export default [
    require("./1.jpg"),
    require("./2.jpg"),
    require("./3.jpg")
]